import { collection, getDocs } from "firebase/firestore";

import { db } from "../firebase";


// pour définir la durée d'une prestation
export function getDuration() {
  return [{ id: -1, name: "Toute la journée" }].concat(
    Array.from(Array(47).keys()).map(I => ({
      id: I + 1,
      name: `${Math.ceil(I / 2)}h${I % 2 ? "30" : "00"}` // Fixed typo here
    }))
  );
}

export function getFormattedDuration(duration) {
  const durationOptions = getDuration();
  const durationItem = durationOptions.find(d => d.id === duration);
  return durationItem ? durationItem.name : duration;
}

export function price(number) {
  return new Intl.NumberFormat("fr-FR", {
    currency: "EUR",
    style: "currency"
  }).format(number);
}


export const getAvailableYears = async userId => {
  const ordersSnapshot = await getDocs(collection(db, `users/${userId}/orders`));
  let minYear = new Date().getFullYear();
  let maxYear = minYear;

  ordersSnapshot.forEach(doc => {
    const order = doc.data();
    const year = new Date(order.selectedDate).getFullYear();

    minYear = Math.min(minYear, year);
    maxYear = Math.max(maxYear, year);
  });

  const years = [];
  for (let year = minYear; year <= maxYear; year++) {
    years.push(year);
  }

  return years;
};

// utils.js

/**
 * Calcule le total des remises en appliquant correctement les pourcentages et les remises fixes.
 */
export const calculateTotalDiscounts = (servicePrice, fees, discounts) => {
  const preDiscountTotal =
    parseFloat(servicePrice) +
    fees.reduce((acc, fee) => acc + fee.feeAmount, 0);

  const fixedDiscountsTotal = discounts.reduce((acc, discount) => {
    return discount.isPercentage ? acc : acc + discount.discountAmount;
  }, 0);

  const totalAfterFixedDiscounts = Math.max(
    0,
    preDiscountTotal - fixedDiscountsTotal
  );

  const percentageDiscountsTotal = discounts.reduce((acc, discount) => {
    if (!discount.isPercentage) {
      return acc;
    }
    return acc + (totalAfterFixedDiscounts * discount.discountAmount) / 100;
  }, 0);

  return Math.min(
    preDiscountTotal,
    fixedDiscountsTotal + percentageDiscountsTotal
  );
};

/**
 * Recalcule les montants de paiements en fonction des pourcentages définis.
 */
export const calculatePaymentValues = (total, percentages) => {
  return percentages.map(percentage => (total * percentage) / 100);
};

/**
 * Calcule la répartition des paiements en fonction du total
 */
export const recalculatePaymentPercentages = (totalPrice, paymentDetails) => {
  if (!totalPrice || totalPrice <= 0) {
    console.error("Le totalPrice est invalide.");
    return [];
  }

  const updatedPercentages = paymentDetails.map(payment => {
    const percentage = ((parseFloat(payment.value) / parseFloat(totalPrice)) * 100).toFixed(2);
    return parseFloat(percentage);
  });

  const totalPercentage = updatedPercentages.reduce((sum, pct) => sum + pct, 0);
  if (totalPercentage !== 100) {
    console.warn(`La somme des pourcentages est ${totalPercentage}% au lieu de 100%.`);
  }

  return updatedPercentages;
};
